<div *ngIf="loadComplete" class="container-block">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <!-- Option màu nền cho frame -->
      <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config" [class]="class" [backgroundClass]="class['frame-result']"
      [backgroundConfig]="config['frame-result']" [isBlock]="false" [id_object]="objectChoosing._id"
      [device]="device">
    </app-background-image-config>

    <app-total-row-col-products-config [objectChoosing]="objectChoosing" [config]="config" [class]="class"
    [productsClass]="class['frame-result__products']" [productsConfig]="config['frame-result__products']"
    [id_object]="objectChoosing._id" [device]="device">
  </app-total-row-col-products-config>

    </div>
  </ng-container>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <div style="margin-top: 10px"></div>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản -->
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <!-- Option màu nền cho frame -->
          <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config" [class]="class" [backgroundClass]="class['frame-result']"
            [backgroundConfig]="config['frame-result']" [isBlock]="false" [id_object]="objectChoosing._id"
            [device]="device">
          </app-background-image-config>

        </div>
      </li>
      <!-- Cấu hình chung -->
      <li nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}" [(nzOpen)]="openMenu.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-total-row-col-products-config [objectChoosing]="objectChoosing" [config]="config" [class]="class"
          [productsClass]="class['frame-result__products']" [productsConfig]="config['frame-result__products']"
          [id_object]="objectChoosing._id" [device]="device">
        </app-total-row-col-products-config>
      </li>
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="{{'cau_hinh_phan_tu' | translate}}" [(nzOpen)]="openMenu.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}} </p>
            <input class="input-color" type="button"
              [style.background]="class['frame-result__products-item--border']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-result__products-item--border']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>

          <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
            [borderClass]="class['frame-result__products-item--border']" [id_object]="objectChoosing._id">
          </app-borders-config>

          <div class="mr-2 mt-2 mb-4 view-more">
            <p class="discover_text" (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
        <!-- Bật đổ bóng -->

        <app-shadow-config [device]="device" [config]="config" [class]="class"
          [shadowClass]="class['frame-result__products-item--border']"
          [shadowConfig]="config['frame-result__products--item']" [objectChoosing]="objectChoosing">
        </app-shadow-config>

      </li>
      <!-- Chọn ngành hàng -->
      <li nz-submenu nzTitle="{{'chon_nganh_hang' | translate}}" 
        [(nzOpen)]="openMenu.menu8" 
        (nzOpenChange)="openHandler('menu8')">
          <mat-form-field appearance="fill" class="w-100">
              <mat-label>{{'chon_nganh_hang' | translate}}</mat-label>
              <mat-select [(ngModel)]="staticdata.main_sector" (ngModelChange)="updateStaticData()">
                  <mat-option *ngFor="let main_sector of main_sectors" [value]="main_sector.value">
                      {{main_sector.label}}
                  </mat-option>
              </mat-select>
          </mat-form-field>
      </li>
      <!-- cach_tim_kiem -->
      <li 
      nz-submenu nzTitle="{{'cach_tim_kiem' | translate}}" 
      [(nzOpen)]="openMenu.menu9" 
      (nzOpenChange)="openHandler('menu9')" >
          <mat-radio-group class="custom-radio" [(ngModel)]="staticdata.type_search" (ngModelChange)="updateStaticData()">
              <mat-radio-button value="ai_search" matTooltipClass="custom-tooltip" matTooltip="{{'su_dung_tri_tue_nhan_tao_de_tim_kiem_chinh_xac_hon_xu_ly_cac_tu_gan_dung_va_cung_cap_goi_y_thong_minh' | translate}}">
              {{'tim_kiem_ai' | translate}}
              </mat-radio-button>
              <mat-radio-button value="regular_search" matTooltipClass="custom-tooltip" matTooltip="{{'tim_kiem_co_ban_hien_thi_ket_qua_chinh_xac_theo_tu_khoa_ban_nhap_vao' | translate}}">
              {{'tim_kiem_tu_khoa' | translate}}
              </mat-radio-button>
          </mat-radio-group>
      </li>
      <!-- Cấu hình khi không tìm thấy sản phẩm -->
      <li nz-submenu nzTitle="{{'cau_hinh_khi_khong_tim_thay_san_pham' | translate}}" [(nzOpen)]="openMenu.menu13"
        (nzOpenChange)="openHandler('menu13')">
        <div class="d-flex justify-content-between align-items-center p-3">
          <p>{{'cau_hinh' | translate}}</p>
          <nz-switch [(ngModel)]="config['is_empty']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <ng-container *ngIf="config['is_empty']">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">
            
          </div>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata['no_data_text_before_' + functionService.selectedLanguageCode] | vhLanguage : 'no_data_text_before' : objectChoosing.component" 
                (ngModelChange)="objectChoosing.staticdata['no_data_text_before_' + functionService.selectedLanguageCode] = $event" 
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </div>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata['no_data_text_after_' + functionService.selectedLanguageCode] | vhLanguage : 'no_data_text_after' : objectChoosing.component" 
                (ngModelChange)="objectChoosing.staticdata['no_data_text_after_' + functionService.selectedLanguageCode] = $event" 
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing"
            [staticdata]="objectChoosing.staticdata" [class]="class" [config]="config"
            [textContentClass]="class['frame-result__products--no-data']"
            [textWrapperClass]="class['frame-result__products--no-data']">
          </app-text-format-config>

          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                      class['frame-result__products--no-data']['letter-spacing'] | vhnumber
                    " (nzBlur)="updateClass()" (ngModelChange)="
                      class['frame-result__products--no-data']['letter-spacing'] = $event + 'px'
                    "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30"
              [ngModel]="class['frame-result__products--no-data']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                    class['frame-result__products--no-data']['letter-spacing'] = $event + 'px'
                  "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> {{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['frame-result__products--no-data']['line-height']"
                (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
              [(ngModel)]="class['frame-result__products--no-data']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </ng-container>
      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['frame-result']"
          [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="mr-2 mb-4 view-more">
          <p class="discover_text" (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['frame-result']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>

    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-result__products-item--border']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

    </div>
  </div>
</div>